export const CLIENT_SET_PASSWORD = "CLIENT_SET_PASSWORD";
export const CLIENT_SET_PASSWORD_ERROR = "CLIENT_SET_PASSWORD_ERROR";
export const CLIENT_SET_PASSWORD_HIDE_ERROR = "CLIENT_SET_PASSWORD_HIDE_ERROR";
export const CLIENT_SET_PASSWORD_START_LOADER = "CLIENT_SET_PASSWORD_START_LOADER";
export const CLIENT_SET_PASSWORD_STOP_LOADER = "CLIENT_SET_PASSWORD_STOP_LOADER";
